var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-date-picker',{attrs:{"limit-from":_vm.limitFrom,"limit-to":_vm.limitTo,"bold":_vm.isRangeTypeInterval,"title":"по","form-group":"","form-group-margin-bottom":"","width":"100px"},model:{value:(_vm.rangeTo),callback:function ($$v) {_vm.rangeTo=$$v},expression:"rangeTo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }